export enum EGrupoProduto {
  IMPRESSORA = 'impressora'
}
